
export default {
    props: {
        salon: {
            type: Object,
            required: true,
            default: null,
        },
        edit: {
            required: false,
            default: false,
            type: Boolean
        },
        layout: {
            required: false,
            default: 'chain',
            type: String
        }
    },
    methods: {
        redirect(salon) {
            // this.$router.push(`/behandlinger/${treatment.urlSafeName}/${treatment.treatmentIdBase64}`)
        }
    },
    computed: {

    }
}
